import classNames from "classnames";
import ActivityActions from "PFApp/components/activity_actions/activity_actions";
import { HeaderTimeAgo } from "PFApp/components/card_tx/header/header_time_ago";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { getProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";

import css from "./header.module.scss";

export type PostHeaderProps = {
  activity: Activity;
  isFeed?: boolean;
  handleEditPost?: (activityId: number) => void;
  handleHeaderClick?: () => void;
  onShare?: (id: number) => void;
  handleCloseActivitySuccess?: () => void;
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
export const PostHeader = ({
  activity,
  handleEditPost,
  handleHeaderClick,
  onShare,
  handleCloseActivitySuccess
}: PostHeaderProps) => (
  <div className={classNames(css.wrapper, css.postHeader)}>
    <div className={classNames(css.section, css.clickable)} onClick={handleHeaderClick}>
      <div className={css.avatarSection}>
        <ProfileAvatar size={40} profile={activity.profile} />
        <div className={css.name} title={getProfileName(activity.profile)}>
          {getProfileName(activity.profile)}
        </div>
      </div>
    </div>
    <div className={classNames(css.section, css.actions)}>
      <HeaderTimeAgo time={activity.created_at} />
      {activity.coowned && (
        <ActivityActions
          activity={activity}
          handleEditPost={handleEditPost}
          handleCloseActivitySuccess={handleCloseActivitySuccess}
          additionalOptions={
            onShare && [
              {
                id: "share",
                displayElement: "Share",
                item: () => onShare(activity.id)
              }
            ]
          }
        />
      )}
    </div>
  </div>
);
